import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import styles from "../../../screens/InternalTracker/InternalTracker.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFilter } from "react-icons/bs";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import {
  fieldStyle,
  prefer_tax_term,
  priority,
  time_zone_choices,
  work_preference,
} from "../../../utils/const2";
import { useDispatch, useSelector } from "react-redux";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import { GoTrash } from "react-icons/go";
import { IoIosSearch } from "react-icons/io";

export default function SearchCandidateList(props) {
  const {
    handleOnClear,
    jobTitles,
    handleOnCLicksearch,
    setSearchData,
    searchData,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.location.data);
  const workautho = useSelector((state) => state.workautho.data);

  useEffect(() => {
    dispatch(allWorkAuthorization());
    dispatch(allLocation());
  }, [dispatch]);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        padding: "15px 5px 20px 10px ",
        margin: "14px 0",
        boxShadow:
          "rgba(14, 30, 37, 0.12) 0px 1px 0px 0px,rgba(14, 30, 37, 0.32) 0px 1px 2px 0px",
      }}
    >
      <Grid container>
        <Grid item xs={12} sm={6} md={1.9} lg={1.9} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography> Candidate Name</Typography>
            <TextField
              id="outlined-basic"
              type="text"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#fff", width: "100%" }}
              name="full_name"
              value={searchData.full_name || ""}
              onChange={(event) => {
                setSearchData((prev) => ({
                  ...prev,
                  full_name: event.target.value, // Updating consultant_name in searchData
                }));
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={2.4} lg={2.4} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>Job Profile</Typography>
            <Autocomplete
              multiple
              id="autocomplete-multi-select"
              options={jobTitles || []}
              disableCloseOnSelect
              value={
                jobTitles?.filter((job) =>
                  searchData.current_job_title?.includes(job)
                ) || []
              }
              onChange={(event, value) => {
                const selectedJobIds = value?.map((job) => job);
                setSearchData((prev) => ({
                  ...prev,
                  current_job_title: selectedJobIds, // Update current_job_title array in searchData
                }));
              }}
              getOptionLabel={(option) => option || ""}
              renderOption={(props, option, { selected }) => (
                <MenuItem {...props}>
                  <Checkbox
                    checked={selected}
                    sx={{ marginRight: 0, marginLeft: 0 }}
                  />
                  <span>{option}</span>
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  name="current_job_title"
                  sx={{ backgroundColor: "#fff", width: "100%" }}
                  placeholder="Select one or more"
                />
              )}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            />
          </Box>
        </Grid>

        {/* <Grid item xs={12} sm={6} md={1.9} lg={1.9} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>Mode of Hiring </Typography>
            <Autocomplete
              multiple
              id="autocomplete-multi-select"
              options={prefer_tax_term || []}
              disableCloseOnSelect
              value={
                prefer_tax_term?.filter((skl) =>
                  searchData.prefer_tax_term?.includes(skl.value)
                ) || []
              }
              onChange={(event, value) => {
                // Update the `searchData` state when skills are selected
                const selectedSkillIds = value?.map((skl) => skl?.value);
                setSearchData((prev) => ({
                  ...prev,
                  prefer_tax_term: selectedSkillIds, // Update the skills array in searchData
                }));
              }}
              getOptionLabel={(option) => option?.label || ""}
              renderOption={(props, option, { selected }) => (
                <MenuItem {...props}>
                  <Checkbox
                    checked={selected}
                    sx={{ marginRight: 0, marginLeft: 0 }}
                  />
                  <span>{option?.label}</span>
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Visa"
                  variant="outlined"
                  size="small"
                  name="taxTerm"
                  sx={fieldStyle}
                />
              )}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={1.9} lg={1.9} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>Visa Status</Typography>
            <Autocomplete
              multiple
              id="autocomplete-multi-select"
              options={workautho?.work_authorization_data || []}
              disableCloseOnSelect
              value={
                workautho?.work_authorization_data?.filter((skl) =>
                  searchData.work_authorization?.includes(skl.id)
                ) || []
              }
              onChange={(event, value) => {
                // Update the `searchData` state when skills are selected
                const selectedSkillIds = value?.map((skl) => skl?.id);
                setSearchData((prev) => ({
                  ...prev,
                  work_authorization: selectedSkillIds, // Update the skills array in searchData
                }));
              }}
              getOptionLabel={(option) => option?.name || ""}
              renderOption={(props, option, { selected }) => (
                <MenuItem {...props}>
                  <Checkbox
                    checked={selected}
                    sx={{ marginRight: 0, marginLeft: 0 }}
                  />
                  <span>{option?.name}</span>
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Visa"
                  variant="outlined"
                  size="small"
                  name="skills"
                  sx={fieldStyle}
                />
              )}
              sx={{ backgroundColor: "#fff", width: "100%" }}
            />
          </Box>
        </Grid> */}

        <Grid item xs={12} sm={6} md={1.9} lg={1.9} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>Location</Typography>
            <Autocomplete
              multiple
              id="autocomplete-multi-select"
              options={locations?.locations || []}
              disableCloseOnSelect
              value={
                locations?.locations?.filter((skl) =>
                  searchData.current_location?.includes(skl.id)
                ) || []
              }
              onChange={(event, value) => {
                // Update the `searchData` state when skills are selected
                const selectedLocationId = value?.map((skl) => skl?.id);
                setSearchData((prev) => ({
                  ...prev,
                  current_location: selectedLocationId, // Update the skills array in searchData
                }));
              }}
              getOptionLabel={(option) => option?.name || ""}
              renderOption={(props, option, { selected }) => (
                <MenuItem {...props}>
                  <Checkbox
                    checked={selected}
                    sx={{ marginRight: 0, marginLeft: 0 }}
                  />
                  <span>{option?.name}</span>
                </MenuItem>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // label="Location"
                  variant="outlined"
                  size="small"
                  name="current_location"
                  sx={fieldStyle}
                />
              )}
              sx={{
                backgroundColor: "#fff",
                width: "100%",
                paddingBottom: "10px",
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={1.9} lg={1.9} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>Form Date</Typography>
            <TextField
              id="outlined-basic"
              type="date"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#fff", width: "100%" }}
              name="start_date"
              value={searchData?.start_date || ""}
              onChange={(event) => {
                setSearchData((prev) => ({
                  ...prev,
                  start_date: event.target.value,
                }));
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={1.9} lg={1.9} sx={{ padding: "0 5px" }}>
          <Box>
            <Typography>To Date</Typography>
            <TextField
              id="outlined-basic"
              type="date"
              variant="outlined"
              size="small"
              sx={{ backgroundColor: "#fff", width: "100%" }}
              name="end_date"
              value={searchData?.end_date || ""}
              onChange={(event) => {
                setSearchData((prev) => ({
                  ...prev,
                  end_date: event.target.value,
                }));
              }}
            />
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={2}
          lg={2}
          sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}
        >
          <Box className={styles.search_btn}>
            <button
              variant="contained"
              style={{ backgroundColor: "#0070c0", marginRight: "10px" }}
              onClick={handleOnCLicksearch}
            >
              Search <IoIosSearch style={{ fontSize: "17px" }} />
              {/* Search */}
            </button>
            <button
              variant="contained"
              style={{ backgroundColor: "#4285f4" }}
              onClick={handleOnClear}
            >
              <GoTrash style={{ fontSize: "17px" }} />
              {/* Clear */}
            </button>
          </Box>
        </Grid>

        {/* <Grid
          item
          xs={12}
          sm={6}
          md={3.5}
          lg={3.5}
          sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}
        >
          <Box className={styles.search_btn}>
            <button
              onClick={handleOnCLicksearch}
              variant="contained"
              style={{ backgroundColor: "3856a6" }}
            >
              Search
            </button>
            <button
              variant="contained"
              style={{ backgroundColor: "#4285f4", marginLeft: "10px" }}
              onClick={handleOnClear}
            >
              Clear
            </button>
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  );
}
